import { connect } from 'react-redux';
import App from './component';

const mapStateToProps = state => {
    return {
        videos: state
    };
};
export const Container = connect(mapStateToProps)(App);